import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const isLinkOrAnchorInSelection = TiptapContentResolver.create((_, __, editor) => {
  const node = editor?.state?.selection?.node;
  if (node) {
    return node.attrs?.link;
  } else {
    return void 0;
  }
});
export {
  isLinkOrAnchorInSelection
};
//# sourceMappingURL=is-link-or-anchor-in-selection.js.map
